/**
 * secretFieldContext — module-level state for the secret field plugin.
 *
 * The Lexical export visitor is a plain object (not a React component), so it
 * cannot access React context or hooks. This module provides a simple
 * getter/setter pair so the visitor can read the current note ID at export
 * time, while React components set it on mount / unmount.
 */

let _currentNoteId: string | null = null;

/**
 * Set the current note ID. Call this when the editor mounts inside a note,
 * and clear it (pass `null`) on unmount.
 */
export function setCurrentNoteId(noteId: string | null): void {
    _currentNoteId = noteId;
}

/**
 * Get the current note ID. Returns `null` if no note is active.
 */
export function getCurrentNoteId(): string | null {
    return _currentNoteId;
}

